import Log from 'forms-utils-lib/logger/Logger';
import { NEW_EDITOR_ERROR_CATEGORIES } from 'FormsUI/api/NewEditorCreation';

// @ts-expect-error untyped file
import { failCreatingNewEditorForm } from 'FormsUI/actions/FormCreation';
const createNewEditorFormXHRError = () => dispatch => {
  dispatch(failCreatingNewEditorForm(NEW_EDITOR_ERROR_CATEGORIES.UNKNOWN));
};
const createNewEditorFormError = error => dispatch => {
  const standardFriendlyError = JSON.parse(error.data);
  Log.error('failed creating new editor form', {
    subCategory: standardFriendlyError.subCategory,
    category: standardFriendlyError.category
  });
  dispatch(createNewEditorFormXHRError());
};
export default createNewEditorFormError;